<template>
  <div>
    <download-excel
      style="width: 100px"
      :fields="json_fields"
      :fetch="startDownload"
      type="xls"
      name="第三方核销表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
     <a-table 
      :columns="columns" 
      :data-source="data" 
      :loading="loading"
      :pagination="pagination"
      :row-key="(record) => record.objId"
      @change="handleTableChange">

    <template slot="is_revoked" slot-scope="text, record">
      <span >{{ record.is_revoked == "0" ? '已核销' : '已撤销' }}</span>
    </template>
    <template slot="operation" slot-scope="text, record">
      <a  @click="buttonRevoke(record)">{{ record.operation && record.is_revoked=="0" ? '撤销' : '' }}</a>
    </template>
  </a-table>
  </div>
</template>
<script>
import { storeOrderThirdTicketsList,storeOrderThirdTicketsCancel,storeOrderThirdAllList } from "@/api/storeApi.js";
import { exchangeOk, exchangeNo } from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    align: "center",
    key: "1",
    width:220,
  },
  {
    title: "卡号",
    dataIndex: "cardNo",
    align: "center",
    key: "2",
  
  },
  {
    title: "核销平台",
    dataIndex: "payName",
    align: "center",
    key: "3",
    width:100,
  
  },
  {
    title: "标题",
    dataIndex: "deal_title",
    align: "center",
    key: "4",

  },
    {
    title: "金额",
    dataIndex: "payAmount",
    key: "11",
    align: "center",
  },
  {
    title: "币数",
    dataIndex: "coins",
    align: "center",
    key: "5",
    width:100,

  },
  {
    title: "次数",
    dataIndex: "frequency",
    align: "center",
    key: "6",
    width:100,
  },
  {
    title: "券码",
    dataIndex: "payCode",
    key: "7",

  },
  {
    title: "核销时间",
    dataIndex: "createTime",
    align: "center",
    key: "8",

  },

  {
    title: "订单状态",
    dataIndex: "is_revoked",
    key: "10",
    scopedSlots: { customRender: "is_revoked" },
  },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    key: "operation",
  },

];


export default {
  data() {
    return {
      data: [],
      json_fields: {
        订单号: "orderNo",
        卡号: "cardNo",
        核销平台: "payName",
        标题: "deal_title",
        核销金额:"payAmount",
        币数: "coins",
        次数: "fequency",
        券码: "payCode",
        核销时间: "createTime",
        
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    // 刚点开的时候自动加载全部数据
    this.getStoreOrderThirdAllList();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    // 查询
    search() {
      this.data = [];
      this.loading = true;

      const params = {
        ...this.formInline,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      storeOrderThirdTicketsList(params).then((res) => {
        this.loading = false;
        if(res.data !=null){
          this.data = res.data;
        }else{
          message.error('暂无数据');
        }
        
        this.pagination.total = Number(res.count);
        this.getTime();
        console.log('请求成功，返回数据:', res);
      }).catch((error) => {
        this.loading = false;
        console.error('请求出错:', error);
        message.error('error', error);
      });
    },
    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const params = {
        ...this.formInline,
        page: 1,
        limit: 1
      };

      
      // 第一步：获取总数量，判断数据规模
      const countRes = await storeOrderThirdAllList(params);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        const params2 = {
        ...this.formInline,
        page: 1,
        limit: totalCount
      };
        // 数据量较小，一次性获取
        const res = await storeOrderThirdAllList(params2);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const params3 = {
              ...this.formInline,
              page: page,
              limit: pageSize
            }
            const res = await storeOrderThirdAllList(params3);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },

    // 分页按钮配置
    handleTableChange(pagination, filters, sorter) {
      console.log('分页变化:', pagination);
      this.pagination.current = pagination.current; //重置当前页
      this.pagination.pageSize = pagination.pageSize; //重置每页条数
      this.search(); //重新查询
    },
 
    // 分页数据
    getOrderThirdTicketsList() {
      this.data = [];
      // 重置分页参数并查询第一页
      this.pagination.current = 1;
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize
      };
      storeOrderThirdTicketsList(params).then((res) => {
        this.pagination.total = Number(res.count);
        if(res.data !=null){
          this.data = res.data;
        }else{
          message.error('暂无数据');
        }
        console.log('请求成功，返回数据:', res);
        this.getTime();
      }).catch((error) => {
        console.error('请求出错:', error);
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },

    getTime() { 
        // 2. 获取当前时间的时间戳
      const nowTimestamp = new Date().getTime();
      for (let i = 0; i < this.data.length; i++) {
        var y = this.data[i];
        // 1. 将 createTime 转换为时间戳（毫秒）
        const createTimestamp = new Date(y.createTime).getTime();

        // 3. 计算时间差（当前时间 - createTime，单位：毫秒）
        const timeDiff = nowTimestamp - createTimestamp;

        // 4. 判断时间差是否小于30分钟（30分钟 = 30×60×1000 = 1800000毫秒）
        // 同时确保时间差 >= 0（避免 createTime 在当前时间之后的情况）
        const operation = timeDiff >= 0 && timeDiff < 1800000;
        y.operation = operation;
      }
      return this.data;
    },
    buttonRevoke(record){
      this.$confirm({
        title: "确定撤销吗?",
        content: "当您点击确定按钮后，该订单会被撤销,如果会员已充值了余额，请人工扣取，否则略过",
        okText: "确定",
        cancelText: "取消",
        onOk: () => {  
          this.loading = true;
          const cancelData={
            objId:record.objId,
            payType:record.payType,
            dealId:record.dealId,
            certificateId:record.certificateId,
            verifyId:record.verifyId,
            payCode:record.payCode,
            shopId:record.shop_id,
            storeId:record.store_id,
          };
          console.log('cancelData:', cancelData);
          storeOrderThirdTicketsCancel(cancelData).then((res) => {
            if(res.success){
              message.success(res.info);
              this.getStoreOrderThirdAllList();
            }else{
              message.error(res.info);
            }
            
          }).catch((error) => {
            message.error(error)
          });
          this.loading = false;
        },
        onCancel() {
          console.log("点击了取消");
        }
      })
      
    },
    getStoreOrderThirdAllList(){
      storeOrderThirdAllList({page:this.pagination.current,limit:this.pagination.pageSize}).then((res) => {
        console.log("getStoreOrderThirdAllList",res);
        if(res.data !=null){
          this.data = res.data;
        }else{
          message.error('暂无数据');
        }
        this.pagination.total = Number(res.count);
        this.getTime();
      }).catch((error) => {
        message.error(error)
      });
    }

  },
};
</script>
<style scoped>
.test {
  position: relative;
  left: 55px;
}

#components-table-demo-summary tfoot th,
#components-table-demo-summary tfoot td {
  background: #fafafa;
}
[data-theme='dark'] #components-table-demo-summary tfoot th,
[data-theme='dark'] #components-table-demo-summary tfoot td {
  background: #1d1d1d;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/verificationSlipOrderTwo/verificationSlipOrderContentTwo.vue